"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_web_svg_charts_1 = require("react-native-web-svg-charts");
const ui_1 = require("@rahtab/ui");
const PendingIcon_1 = __importDefault(require("@rahtab/ui/dist/icons/PendingIcon"));
const string_1 = require("../../tools/string");
const LoadPieChart = ({ correctionAmount, remainedAmount, returnedAmount, saledAmount, correctionPercent, remainedPercent, returnedPercent, saledPercent, measureName, }) => {
    const totalAmount = saledAmount + remainedAmount + returnedAmount + correctionAmount;
    const chartData = [
        (saledAmount / totalAmount) * 360,
        (remainedAmount / totalAmount) * 360,
        (correctionAmount / totalAmount) * 360,
        (returnedAmount / totalAmount) * 360,
    ];
    const colors = [ui_1.Colors.secondary, ui_1.Colors.primary, ui_1.Colors.darkGray, 'darkblue'];
    const pieData = chartData.map((value, index) => ({
        value,
        svg: {
            fill: colors[index],
            onPress: () => console.log('press', index),
        },
        key: `pie-${index}`,
    }));
    return (react_1.default.createElement(ui_1.Card, { style: react_native_1.StyleSheet.flatten([styles.card, styles.chart]) },
        react_1.default.createElement(ui_1.CardCaption, null,
            react_1.default.createElement(ui_1.Text, { variant: "cardTitle", color: "primary", margin: "none", style: { textAlign: 'center' } }, "\u0645\u0648\u062C\u0648\u062F\u06CC \u0628\u0627\u0631 \u062F\u0631\u06CC\u0627\u0641\u062A\u06CC")),
        react_1.default.createElement(ui_1.CardContainer, null,
            react_1.default.createElement(react_native_web_svg_charts_1.PieChart, { style: { height: 200 }, outerRadius: "80%", padAngle: 0, data: pieData }),
            react_1.default.createElement(react_native_1.View, { style: styles.rowLine },
                react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                    react_1.default.createElement(PendingIcon_1.default, { fill: ui_1.Colors.secondary, style: styles.dotIcon }),
                    react_1.default.createElement(ui_1.Text, { margin: "none", color: "description" },
                        "\u0645\u0642\u062F\u0627\u0631 \u0641\u0631\u0648\u0634:",
                        ' ',
                        react_1.default.createElement(ui_1.Text, { margin: "none" },
                            string_1.withSeparator(saledAmount),
                            " ",
                            measureName))),
                react_1.default.createElement(ui_1.Text, { color: "secondary", margin: "none" },
                    "\u066A",
                    saledPercent)),
            react_1.default.createElement(react_native_1.View, { style: styles.rowLine },
                react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                    react_1.default.createElement(PendingIcon_1.default, { fill: ui_1.Colors.primary, style: styles.dotIcon }),
                    react_1.default.createElement(ui_1.Text, { margin: "none", color: "description" },
                        "\u062A\u0631\u0627\u0632 \u0645\u0648\u062C\u0648\u062F\u06CC:",
                        ' ',
                        react_1.default.createElement(ui_1.Text, { margin: "none" },
                            string_1.withSeparator(remainedAmount),
                            " ",
                            measureName))),
                react_1.default.createElement(ui_1.Text, { color: "primary", margin: "none" },
                    "\u066A",
                    remainedPercent)),
            react_1.default.createElement(react_native_1.View, { style: styles.rowLine },
                react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                    react_1.default.createElement(PendingIcon_1.default, { fill: ui_1.Colors.darkGray, style: styles.dotIcon }),
                    react_1.default.createElement(ui_1.Text, { margin: "none", color: "description" },
                        "\u0645\u0642\u062F\u0627\u0631 \u0627\u0635\u0644\u0627\u062D\u06CC\u0627\u062A \u0645\u0648\u062C\u0648\u062F\u06CC:",
                        ' ',
                        react_1.default.createElement(ui_1.Text, { margin: "none" },
                            string_1.withSeparator(correctionAmount),
                            " ",
                            measureName))),
                react_1.default.createElement(ui_1.Text, { style: { color: ui_1.Colors.darkGray }, margin: "none" },
                    "\u066A",
                    correctionPercent)),
            react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.rowLine, { marginBottom: 0 }]) },
                react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                    react_1.default.createElement(PendingIcon_1.default, { fill: 'darkblue', style: styles.dotIcon }),
                    react_1.default.createElement(ui_1.Text, { margin: "none", color: "description" },
                        "\u0645\u0642\u062F\u0627\u0631 \u0628\u0627\u0632\u06AF\u0634\u062A\u200C \u0634\u062F\u0647:",
                        ' ',
                        react_1.default.createElement(ui_1.Text, { margin: "none" },
                            string_1.withSeparator(returnedAmount),
                            " ",
                            measureName))),
                react_1.default.createElement(ui_1.Text, { style: { color: 'darkblue' }, margin: "none" },
                    "\u066A",
                    returnedPercent)))));
};
exports.default = LoadPieChart;
const styles = react_native_1.StyleSheet.create({
    card: {
        marginHorizontal: ui_1.getSpacing(),
        marginTop: ui_1.getSpacing(),
    },
    rowLine: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: ui_1.getSpacing(),
    },
    rowView: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    chart: {
        justifyContent: 'center',
        marginBottom: ui_1.getSpacing(0.5),
    },
    dotIcon: {
        marginRight: ui_1.getSpacing(),
        marginTop: 3,
    },
    caption: {
        alignItems: 'center',
    },
});
